export default {
    /**
     * Datos añadidos a data por el mixin:
     * - maritalStatusOptions: array con tipos de vias
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            maritalStatusOptions: []
        };
    },
    methods: {
        /**
         * Load street types
         */
        loadMaritalStatusOptions() {
            const maritalStatus = this.$t("maritalStatus", { returnObjects: true });
            this.maritalStatusOptions = Object.entries(maritalStatus).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de vías en la variable
     * `this.loadMaritalStatusOptions`
     */
    beforeMount() {
        this.loadMaritalStatusOptions();
    }
};
